import { type AIProviderId, getAIProvider } from "../../shared/aiProviders";
import anthropicLogo from "../../shared/connectors/anthropic/logo.svg";
import apiKeyLogo from "../../shared/connectors/apiKey/logo.svg";
import azureLogo from "../../shared/connectors/microsoftAzure/logo.svg";
import openaiLogo from "../../shared/connectors/openai/logo.svg";
import oracleOciLogo from "../../shared/connectors/oracleOci/logo.svg";

const providerLogos: Record<AIProviderId, string> = {
  anthropic: anthropicLogo,
  "bedrock-anthropic": anthropicLogo,
  openai: openaiLogo,
  "openai-compatible": apiKeyLogo,
  azure: azureLogo,
  "oracle-oci": oracleOciLogo,
};

export function ProviderLogo({
  provider,
  size = 16,
  onDark = false,
}: {
  provider: AIProviderId;
  size?: number;
  onDark?: boolean;
}) {
  return (
    <img
      alt={getAIProvider(provider).label}
      src={providerLogos[provider]}
      style={{
        width: size,
        height: size,
        flexShrink: 0,
        // Logos are monochrome but theme-adaptive (light-dark fill). On the
        // always-dark strip, force them white so they don't flip per theme.
        ...(onDark && { filter: "brightness(0) invert(1)" }),
      }}
    />
  );
}
